"use client";

import dynamic from "next/dynamic";
const styles = new Proxy({"ParallaxSection":"ParallaxSection-d3e81","container":"container-d3e81","content":"content-d3e81","sectionTitle":"sectionTitle-d3e81","stepsContainer":"stepsContainer-d3e81","step":"step-d3e81","visible":"visible-d3e81","stepBackgroundImage":"stepBackgroundImage-d3e81","stepInner":"stepInner-d3e81","horizontal":"horizontal-d3e81","vertical":"vertical-d3e81","stepContent":"stepContent-d3e81","contentLeft":"contentLeft-d3e81","contentCenter":"contentCenter-d3e81","contentRight":"contentRight-d3e81","headline":"headline-d3e81","subheadline":"subheadline-d3e81","bodyText":"bodyText-d3e81","ctaButton":"ctaButton-d3e81","stepImage":"stepImage-d3e81","imageLeft":"imageLeft-d3e81","imageRight":"imageRight-d3e81","imageAbove":"imageAbove-d3e81","imageBelow":"imageBelow-d3e81","backgroundLayers":"backgroundLayers-d3e81","backgroundLayer":"backgroundLayer-d3e81","progressIndicator":"progressIndicator-d3e81","progressDots":"progressDots-d3e81","progressDot":"progressDot-d3e81","active":"active-d3e81","completed":"completed-d3e81","progressLine":"progressLine-d3e81","progressLineFill":"progressLineFill-d3e81","progressNumbers":"progressNumbers-d3e81","currentStep":"currentStep-d3e81","separator":"separator-d3e81","totalSteps":"totalSteps-d3e81","loading":"loading-d3e81","spinner":"spinner-d3e81","emptyState":"emptyState-d3e81"}, { get: (m, k) => (typeof k === "string" ? (m[k] ?? k) : m[k]) });
import type { ParallaxSectionProps } from "./types";
import { filterFilledItems } from "../../lib/filterFilledItems";

const ParallaxSectionClient = dynamic(() => import("./ParallaxSectionClient"), {
  ssr: false,
  loading: () => (
    <div className={styles.loading}>
      <div className={styles.spinner} />
    </div>
  ),
});

export default function ParallaxSection({ block }: ParallaxSectionProps) {
  const {
    sectionHeight = 300,
    backgroundColor = "#1D3241",
    steps = [],
  } = block;

  const filledSteps = filterFilledItems(steps, ["headline"]);

  if (!filledSteps || filledSteps.length === 0) {
    return (
      <section className={styles.ParallaxSection} style={{ backgroundColor }}>
        <div className={styles.emptyState}>
          <p>No steps configured for this parallax section</p>
        </div>
      </section>
    );
  }

  return (
    <section
      className={styles.ParallaxSection}
      style={{
        backgroundColor,
        height: `${sectionHeight}vh`,
      }}
    >
      <ParallaxSectionClient block={{ ...block, steps: filledSteps }} />
    </section>
  );
}
